import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import BienAVendreFilters from 'enums/BienAVendreFilters'
import { Status } from '../utilisateur/slice'

const name = 'bienAVendreResultFilter'

export interface FilterResultState {
  filter: BienAVendreFilters | null
  errorMsg: string | null
  status: Status
}

const initialState: FilterResultState = {
  filter: BienAVendreFilters.Tous,
  errorMsg: null,
  status: Status.Idle,
}

const filterResultSlice = createSlice({
  name,
  initialState,
  reducers: {
    toggleFilterResult: (state, action: PayloadAction<BienAVendreFilters>) => {
      state.filter = action.payload
    },
    loading: (state) => {
      state.status = Status.Pending
      state.filter = null
      state.errorMsg = null
    },
    error: (state, action) => {
      state.errorMsg = action.payload
      state.status = Status.Failed
      state.filter = null
    },
  },
})

export const { toggleFilterResult } = filterResultSlice.actions

export default filterResultSlice
